// extracted by mini-css-extract-plugin
export default {"modalAlert":"ModalAlert_modalAlert__wZx4l","buttonContainer":"ModalAlert_buttonContainer__RUlqQ","buttonOk":"ModalAlert_buttonOk__tVApv"};